import { getThumbBySize } from '../../../../../util/photo';
import { IMAGE_SIZE_CODE } from '../../../../../constants/image-size-codes';

/**
 * Attempts to extract the backdrop of an AlbumFolder for usage in onboarding.
 *
 * @param {Object} albumFolder The AlbumFolder.
 * @returns {string|undefined}
 */
export const getAlbumFolderOnboardingBackdropSrc = albumFolder => {
  if (!albumFolder) {
    return '';
  }

  const [coverPhoto] = albumFolder.cover_photos?.records ?? [];

  return getThumbBySize(coverPhoto?.thumbnail_urls, IMAGE_SIZE_CODE.LARGE)?.url;
};

/**
 * Determines if a given pathname route requres flexible height class
 *
 * @param {String} pathname the pathname to check
 *
 * @returns {boolean}
 */
export const routeRequiresFlexibleHeight = pathname => {
  const flexibleHeightRoutes = ['/photo-search-checkout'];

  return !!flexibleHeightRoutes.find(path => pathname.includes(path));
};
